// extracted by mini-css-extract-plugin
export var trigger = "CompareTableModal-module--trigger--99d90";
export var triggerWrapper = "CompareTableModal-module--triggerWrapper--87124";